var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-left buyer-select" }, [
    _vm.label && !_vm.hideLabel
      ? _c(
          "label",
          {
            staticClass: "text-brand-secondary",
            class: [
              _vm.type === "sales" ? "font-bold mb-_5 block md_text-sm" : null,
              { "text-xl md_text-base": _vm.labelLarge }
            ]
          },
          [
            _vm._v(_vm._s(_vm.label) + " "),
            _vm.optional
              ? _c("span", { staticClass: "text-brand-secondary-100" }, [
                  _vm._v("(optional)")
                ])
              : _vm._e()
          ]
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "relative" },
      [
        _c(
          "select",
          {
            staticClass:
              "relative z-20 rounded-none appearance-none bg-transparent border text-xl md_text-base py-1 md_py-_75 pl-1 pr-2 w-full cursor-pointer disabled_opacity-50 disabled_cursor-not-allowed",
            class: _vm.classes,
            attrs: {
              id: _vm.id,
              "aria-label": _vm.label,
              "aria-describedby":
                _vm.error && _vm.errorVisible ? _vm.errorId : null,
              "aria-invalid": _vm.error && _vm.errorVisible ? "true" : "false",
              "aria-disabled": _vm.disabled ? "true" : "false",
              disabled: _vm.disabled
            },
            domProps: { value: _vm.value },
            on: {
              change: function($event) {
                return _vm.$emit("input", $event)
              }
            }
          },
          [_vm._t("default")],
          2
        ),
        _c("icon-chevron-down", {
          staticClass: "absolute absolute--center-vertical right-1 z-10",
          class: _vm.chevronClass
        }),
        _c("div", {
          staticClass: "absolute top-0 left-0 h-full w-full z-0",
          class: _vm.type === "footer" ? "bg-transparent" : "bg-white"
        })
      ],
      1
    ),
    _vm.error && _vm.errorVisible
      ? _c(
          "div",
          {
            staticClass: "mt-_5 text-error text-sm",
            attrs: { id: _vm.errorId }
          },
          [_vm._v(_vm._s(_vm.error))]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }